const permission = {
  inserted: function (el, binding) {
    const { permConfig, permKey } = binding.value || {}
    const configItems = (permConfig || {}).configItems || []
    for (let i = 0; i < configItems.length; i++) {
      const { key, type, value } = configItems[i]
      if (key === permKey) {
        switch (type) {
          case 'SHOW_HIDE':
            if (value === 'hidden') {
              el.parentNode && el.parentNode.removeChild(el)
            }
            break
        }
        break
      }
    }
  }
}

export default permission
